export default __webpack_public_path__ + "media/images/flags/ia-77279c4685a6c7e256493c7b51327246.png";